export default __webpack_public_path__ + "static/media/CMS-example.c4e37746.pdf";